jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

const readMoreBtn = document.getElementById("readMorefabric");
const extraContent = document.getElementById("extraContentfabric");

readMoreBtn?.addEventListener("click", () => {
  extraContent.style.display = extraContent.style.display === "block" ? "none" : "block";
  readMoreBtn.classList.toggle("expanded");
});

});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.read-more-toggle').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const container = e.target.closest('.desc-head');
      const shortDesc = container.querySelector('.short-desc');
      const fullDesc = container.querySelector('.full-desc');

      const isExpanded = fullDesc.style.display === 'inline';

      shortDesc.style.display = isExpanded ? 'inline' : 'none';
      fullDesc.style.display = isExpanded ? 'none' : 'inline';
      e.target.textContent = isExpanded ? 'Read more' : 'Read less';
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const cleanUpFlickityStyles = () => {
    document.querySelectorAll('.flickityt4s-slider .t4s-cat-item').forEach(item => {
      item.style.position = '';
      item.style.transform = '';
    });
  };

  // Clean once initially
  cleanUpFlickityStyles();

  // Watch for DOM mutations that Flickity might trigger
  const observer = new MutationObserver(cleanUpFlickityStyles);
  const slider = document.querySelector('.flickityt4s-slider');
  if (slider) {
    observer.observe(slider, { childList: true, subtree: true, attributes: true });
  }
});

window.addEventListener('scroll', function() {
    if (window.scrollY > 70) {
        document.body.classList.add('sticky_cstm');
    } else {
        document.body.classList.remove('sticky_cstm');
    }
});




